// Display helpers for the OT Nationals live-stats sections (TECHENG-725 contract §1).

const ORDINALS: Record<number, string> = { 1: '1st', 2: '2nd', 3: '3rd', 4: '4th' };

/** Quarter or overtime label: Q1-Q4, then OT, 2OT, 3OT... */
export const periodLabel = (period?: number | null): string => {
	if (!period || period < 1) return '';
	if (period <= 4) return `Q${period}`;
	const ot = period - 4;
	return ot === 1 ? 'OT' : `${ot}OT`;
};

export const downAndDistanceLabel = (
	down?: number | null,
	distance?: number | null,
	isGoalToGo?: boolean,
): string | null => {
	if (!down || !ORDINALS[down]) return null;
	if (isGoalToGo) return `${ORDINALS[down]} & Goal`;
	if (distance == null) return ORDINALS[down];
	return `${ORDINALS[down]} & ${distance < 1 ? 'Inches' : distance}`;
};

/**
 * Ball spot from a yard line measured from the possession team's own goal: "SFA 44",
 * "CCH 31" or "50". Falls back to OWN / OPP when team codes are unknown.
 */
export const ballOnLabel = (
	yardLine?: number | null,
	possessionCode?: string | null,
	opponentCode?: string | null,
): string | null => {
	if (yardLine == null || yardLine < 0 || yardLine > 100) return null;
	if (yardLine === 50) return '50';
	if (yardLine < 50) return `${(possessionCode || 'OWN').toUpperCase()} ${yardLine}`;
	return `${(opponentCode || 'OPP').toUpperCase()} ${100 - yardLine}`;
};

/** mm:ss from milliseconds, or null when the clock wasn't recorded (the usual case). */
export const optionalClockLabel = (ms?: number | null): string | null => {
	if (ms == null) return null;
	const totalSeconds = Math.max(0, Math.floor(ms / 1000));
	return `${Math.floor(totalSeconds / 60)}:${String(totalSeconds % 60).padStart(2, '0')}`;
};
